export const SERIALIZATION_KEY_BACKOFFICE = 'backoffice';
export const SERIALIZATION_KEY_BACKOFFICE_LIST = 'backoffice_list';
